export default "<div class=\"vle-scroll-container\" [class.vle-scroll-container--thin]=\"isThin\">\n  <ng-content></ng-content>\n</div>\n";